import { Box, Button, Card, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link as RouterLink } from 'react-router'

interface Props {
  resourceName?: string
  actionLabel?: string
  actionTo?: string
}

const AccessDenied = ({ resourceName, actionLabel, actionTo }: Props) => {
  const { t } = useTranslation()

  const _resourceName = resourceName || t('access.resource')

  return (
    <Card sx={{ width: '60%', py: 5, px: 2, mx: 'auto', my: 5 }}>
      <Typography textAlign={'center'}>
        {t('access.accessDenied', { resourceName: _resourceName })}
      </Typography>
      {actionLabel && actionTo ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
          <Button variant='contained' component={RouterLink} to={actionTo}>
            {actionLabel}
          </Button>
        </Box>
      ) : null}
    </Card>
  )
}

export default AccessDenied
